export default function ApiError (error, payload = undefined) {
  return {
    url: error.url,
    code: error.code,
    errorTitle: error.errorTitle,
    errorMessage: error.errorMessage,
    helpUrl: error.helpUrl,
    data: error.data,
    payload: payload,
  };
}

export const newApiError = (code, title, message, url = undefined, helpUrl = undefined) => {
  return ApiError({
    url,
    code,
    errorTitle: title,
    errorMessage: message,
    helpUrl: helpUrl,
    payload: null
  });
};

export const new400Error = (title, message, url = undefined, helpUrl = undefined) => {
  return newApiError(400, title, message, url, helpUrl);
};

export const new401Error = (title, message, url = undefined, helpUrl = undefined) => {
  return newApiError(401, title, message, url, helpUrl);
};

export const new403Error = (title, message, url = undefined, helpUrl = undefined) => {
  return newApiError(403, title, message, url, helpUrl);
};

export const new404Error = (title, message, url = undefined, helpUrl = undefined) => {
  return newApiError(404, title, message, url, helpUrl);
};

export const new500Error = (title, message, url = undefined, helpUrl = undefined) => {
  return newApiError(500, title, message, url, helpUrl);
};
